import { ResolveState } from '../../../common';
import { Updater } from '../../../upgrade/models/updater-interface';
import { ErrorResult } from '../../../upgrade/models/error-result';
import { Logger } from '../../utils/logger';
import { IiFUpdaterUtil } from './iif-updater-util';
import { SubjectNextUpdaterUtil } from './subjuct-next-updater-util';

/**
 * the ParameterCountViolationUpdater error handler/updater.
 */
export class ParameterCountViolationUpdater implements Updater {
    /**
     * the update function.
     * @param fileData the file data.
     * @param error the error object.
     * @returns the updated file data.
     */
    public update(fileData: string, error: ErrorResult): Promise<string> {
        if (!fileData) {
            Logger.error(`Cannot find file data`);
        }
        const errorLineContent = fileData.split('\n')[error.position.line - 1];

        let result = fileData;
        Logger.log('line content: ' + errorLineContent);

        if (errorLineContent.includes('iif')) {
            const updater = new IiFUpdaterUtil();
            result = updater.update(fileData, error);
        } else if (errorLineContent.includes('next')) {
            const updater = new SubjectNextUpdaterUtil();
            result = updater.update(fileData, error);
        } else {
            Logger.log('Found no updater for this error: ' + JSON.stringify(error));
        }

        error.resolved = ResolveState.Resolved;
        return new Promise(resolve => resolve(result));
    }
}
